"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = require("../../../Grid");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Title = _styledComponents.default.h1.withConfig({
  displayName: "Header__Title",
  componentId: "sc-1a1hybq-0"
})(["display:inline;line-height:", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.immersiveFlow.immersiveFlowMobileHeight;
}, function (_ref2) {
  var _ref2$theme = _ref2.theme,
      media = _ref2$theme.media,
      immersiveFlow = _ref2$theme.immersiveFlow;
  return media.medium((0, _styledComponents.css)(["line-height:", ";"], immersiveFlow.immersiveFlowHeight));
});

var Header = _styledComponents.default.header.withConfig({
  displayName: "Header",
  componentId: "sc-1a1hybq-1"
})(["background:", ";color:", ";flex:0 0 auto;height:", ";line-height:", ";position:fixed;width:100%;z-index:100;", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.neutral.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary.nmBlue;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.immersiveFlow.immersiveFlowMobileHeight;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.immersiveFlow.immersiveFlowMobileHeight;
}, function (_ref7) {
  var _ref7$theme = _ref7.theme,
      media = _ref7$theme.media,
      immersiveFlow = _ref7$theme.immersiveFlow;
  return media.medium((0, _styledComponents.css)(["height:", ";line-height:", ";"], immersiveFlow.immersiveFlowHeight, immersiveFlow.immersiveFlowHeight));
});

var HeaderRow = (0, _styledComponents.default)(_Grid.Row).withConfig({
  displayName: "Header__HeaderRow",
  componentId: "sc-1a1hybq-2"
})(["height:100%;padding-left:", ";padding-right:", ";", ";", ";"], (0, _polished.rem)('18px'), (0, _polished.rem)('18px'), function (_ref8) {
  var media = _ref8.theme.media;
  return media.medium((0, _styledComponents.css)(["padding-left:", ";padding-right:", ";"], function (props) {
    return props.theme.spacing.large;
  }, function (props) {
    return props.theme.spacing.large;
  }));
}, function (_ref9) {
  var media = _ref9.theme.media;
  return media.large((0, _styledComponents.css)(["padding-left:", ";padding-right:", ";"], function (props) {
    return props.theme.spacing.xxlarge;
  }, function (props) {
    return props.theme.spacing.xxlarge;
  }));
});
var HeaderCol = (0, _styledComponents.default)(_Grid.Col).withConfig({
  displayName: "Header__HeaderCol",
  componentId: "sc-1a1hybq-3"
})(["overflow:hidden;text-overflow:ellipsis;text-align:center;white-space:nowrap;"]);
var Progress = (0, _styledComponents.default)(_Grid.Row).withConfig({
  displayName: "Header__Progress",
  componentId: "sc-1a1hybq-4"
})(["background:", ";height:", ";"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.neutral.nickel;
}, function (props) {
  return props.theme.spacing.xsmall;
});
var ProgressCompleted = (0, _styledComponents.default)(_Grid.Col).withConfig({
  displayName: "Header__ProgressCompleted",
  componentId: "sc-1a1hybq-5"
})(["background:", ";transition-property:max-width,flex;transition-duration:0.5s;transition-timing-function:cubic-bezier(0.445,0.05,0.55,0.95);"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.accent.blue;
});

var Border = function Border(_ref12) {
  var currentStep = _ref12.currentStep,
      totalSteps = _ref12.totalSteps;

  if (currentStep && totalSteps) {
    var progressValue = parseInt(12 * currentStep / totalSteps);
    return /*#__PURE__*/_react.default.createElement(Progress, null, /*#__PURE__*/_react.default.createElement(ProgressCompleted, {
      small: progressValue
    }));
  }

  return null;
};

var ImmersiveFlowHeader = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(ImmersiveFlowHeader, _React$Component);

  var _super = _createSuper(ImmersiveFlowHeader);

  function ImmersiveFlowHeader() {
    (0, _classCallCheck2.default)(this, ImmersiveFlowHeader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ImmersiveFlowHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          PrefixComponent = _this$props.PrefixComponent,
          PostfixComponent = _this$props.PostfixComponent,
          title = _this$props.title,
          currentStep = _this$props.currentStep,
          totalSteps = _this$props.totalSteps;
      return /*#__PURE__*/_react.default.createElement(Header, {
        name: "header",
        className: this.props.className
      }, /*#__PURE__*/_react.default.createElement(HeaderRow, {
        name: "header-row"
      }, PrefixComponent, /*#__PURE__*/_react.default.createElement(HeaderCol, {
        small: true
      }, title && /*#__PURE__*/_react.default.createElement(Title, {
        className: "ui-h6"
      }, title)), PostfixComponent), /*#__PURE__*/_react.default.createElement(Border, {
        currentStep: currentStep,
        totalSteps: totalSteps
      }));
    }
  }]);
  return ImmersiveFlowHeader;
}(_react.default.Component);

ImmersiveFlowHeader.defaultProps = {};
ImmersiveFlowHeader.propTypes = {
  /** Custom class name to add to Header. */
  className: _propTypes.default.string,

  /** The current step user is on. */
  currentStep: _propTypes.default.number,

  /** Total number of steps in flow (used for progress bar). */
  totalSteps: _propTypes.default.number,

  /** Place a React component after the title column. */
  PostfixComponent: _propTypes.default.node,

  /** Place a React component before the title column. */
  PrefixComponent: _propTypes.default.node,

  /** Title in the top middle. **/
  title: _propTypes.default.string
};
var _default = ImmersiveFlowHeader;
exports.default = _default;
//# sourceMappingURL=Header.js.map